export default __webpack_public_path__ + "static/media/page-speed.88c6402a.png";